import "./icons/cupcake.svg"

export default {
    name: "cupcake",
    viewBox: "25 25",
}
